import { GET_ALL_INQUIRIES_SUCCESS, GET_ALL_INQUIRIES_FAIL, LOGOUT, GET_ALL_INQUIRIES_REQUEST } from "../actions/types"
import { GET_ALL_INQUIRY_TYPES_SUCCESS, GET_ALL_INQUIRY_TYPES_FAIL,GET_ALL_INQUIRY_TYPES_REQUEST } from "../actions/types"

const initialState = { inquiries: null, inquiryTypes:null,loading: false, error: null };

export const getAllInquiryReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_INQUIRIES_REQUEST:
      return {
        ...state,

        inquiries: null,
        loading: true,
      };
    case GET_ALL_INQUIRIES_SUCCESS:
      return {
        ...state,
        inquiries: payload,
        loading: false,
      };
    case GET_ALL_INQUIRIES_FAIL:
      return {
        ...state,
        inquiries: [],
        error: payload,
        loading: false,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     inquiries: false,
    //     user: null,
    //   };
    default:
      return state;
  }
};

export const getAllInquiryTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_INQUIRY_TYPES_REQUEST:
      return {
        ...state,

        inquiryTypes: null,
        loading: true,
      };
    case GET_ALL_INQUIRY_TYPES_SUCCESS:
      return {
        ...state,
        inquiryTypes: payload,
        loading: false,
      };
    case GET_ALL_INQUIRY_TYPES_FAIL:
      return {
        ...state,
        inquiryTypes: [],
        error: payload,
        loading: false,
      };
    // case LOGOUT:
    //   return {
    //     ...state,
    //     inquiries: false,
    //     user: null,
    //   };
    default:
      return state;
  }
}